import { DatePipe, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RestrictedNavigationService } from '@services/restricted-navigation.service';

@Component({
  selector: 'app-stallion-layout',
  templateUrl: './stallion-layout.component.html',
  styleUrls: ['./stallion-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, DatePipe, NgOptimizedImage],
})
export class StallionLayoutComponent implements OnInit {
  public restrictedNavigation: boolean = false;
  public today: Date = new Date();

  private restrictedNavigationService = inject(RestrictedNavigationService);

  public ngOnInit(): void {
    this.restrictedNavigationService.restrictedNavigationObserver.subscribe((r) => (this.restrictedNavigation = r));
  }
}
